import React from 'react'
import cx from 'classnames'

type CardProps = React.HTMLAttributes<HTMLElement> & {
  title?: string
  actions?: React.ReactNode
}

export const Card = ({
  title = '',
  actions,
  children,
  className,
  ...props
}: CardProps) => (
  <article className={cx('Card', className)} {...props}>
    {children}
  </article>
)

export default Card
